import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';

import qs from 'qs';

import { Button, ButtonGroup, Modal } from '@salesforce/design-system-react';
import { FrequencyChart, NoData } from './';
import { sendEvent } from '../../utilities/instrumentation';
import redirectToError from '../../common/redirectToError';
import './ChartContent.scss';

export class ChartContent extends Component {
  constructor(props) {
    super(props);
    this.modalName = 'expandedChartModal';
  }

  renderChart(
    frequencies,
    visualMode = FrequencyChart.visualModes.standard,
    scrollable = false
  ) {
    return (
      <FrequencyChart
        frequencies={frequencies}
        chartParams={this.props.chartParams}
        scrollable={scrollable}
        visualMode={visualMode}
      />
    );
  }

  renderChartSubtitleMessage() {
    const { formatNumber } = this.props.intl;
    const {
      totalSubscribers,
      totalEmailSent,
      averageOpenRate,
      averageClickRate,
      averageUnsubscribeRate
    } = this.props.frequencies.data.aggregates;
    return (
      <FormattedMessage
        id="FrequencyChart.subheader"
        values={{
          totalEmailSent: <strong>{formatNumber(totalEmailSent)}</strong>,
          totalSubscribers: <strong>{formatNumber(totalSubscribers)}</strong>,
          averageOpenRate: (
            <strong className="open-rate">
              {this.formatRatePercentage(averageOpenRate)}
            </strong>
          ),
          averageClickRate: (
            <strong className="click-rate">
              {this.formatRatePercentage(averageClickRate)}
            </strong>
          ),
          averageUnsubscribeRate: (
            <strong className="unsubscribe-rate">
              {this.formatRatePercentage(averageUnsubscribeRate)}
            </strong>
          )
        }}
      />
    );
  }

  formatRatePercentage(rate) {
    const { formatNumber } = this.props.intl;
    return formatNumber(rate, {
      style: 'percent',
      maximumFractionDigits: 2
    });
  }

  handleChartModalOpen() {
    this.props.actions.openModal(this.modalName);
    sendEvent('clickButton', 'expandedChartOpen');
  }

  handleChartModalClose() {
    this.props.actions.closeModal(this.modalName);
  }

  handleRefreshClick() {
    const options = {
      ...qs.parse(this.props.location.search.substr(1)),
      onError: redirectToError(this.props.history)
    };
    this.props.actions.getFrequenciesData(options, this.props.chartParams);
    sendEvent('clickButton', 'chartRefresh');
  }

  render() {
    const { frequencies: frequencyRows } = this.props.frequencies.data;
    const isChartModalOpen = Boolean(
      this.props.modals[this.modalName] &&
        this.props.modals[this.modalName].isOpen
    );
    return frequencyRows && frequencyRows.length > 0 ? (
      <div>
        <header className="chart-heading-container slds-grid">
          <div className="slds-col chart-header-title">
            <h3>
              <FormattedMessage id="FrequencyChart.header" />
            </h3>
            <p>{this.renderChartSubtitleMessage()}</p>
          </div>
          <ButtonGroup className="slds-col slds-no-flex">
            <Button
              assistiveText={{ icon: 'Refresh' }}
              iconCategory="utility"
              iconName="refresh"
              iconVariant="border-filled"
              iconSize="large"
              variant="icon"
              className="chart-button"
              onClick={() => this.handleRefreshClick()}
            />
            <Button
              assistiveText={{ icon: 'Expand' }}
              iconCategory="utility"
              iconName="expand"
              iconVariant="border-filled"
              iconSize="large"
              variant="icon"
              className="chart-button"
              onClick={() => this.handleChartModalOpen()}
            />
          </ButtonGroup>
        </header>
        <div>{this.renderChart(frequencyRows)}</div>
        <Modal
          isOpen={isChartModalOpen}
          onRequestClose={() => this.handleChartModalClose()}
          tagline={this.renderChartSubtitleMessage()}
          title={<FormattedMessage id="FrequencyChart.header" />}
          size="large"
          headerClassName="expanded-chart-heading-container"
          contentClassName="expanded-chart-content"
        >
          {this.renderChart(
            frequencyRows,
            FrequencyChart.visualModes.expanded,
            true
          )}
        </Modal>
      </div>
    ) : (
      <div>
        <NoData />
      </div>
    );
  }
}

ChartContent.propTypes = {
  children: PropTypes.element,
  location: PropTypes.object.isRequired,
  frequencies: PropTypes.object.isRequired,
  chartParams: PropTypes.object.isRequired,
  actions: PropTypes.object,
  modals: PropTypes.object,
  intl: intlShape.isRequired
};

export default injectIntl(ChartContent);
